import React from "react";
import { IconContainer, IconText, SpaceBetweenStack, StyledBlackInformationTypography, StyledDarkRedInformationTypography, StyledRightAlignedStack, StyledStack } from "../../../components/commonComponents/StyledComponents/styled";
import { Box, Link, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../Store/actions";
import { TextButton } from "../../../components/commonComponents/Buttons/ActionButton";
import { fetchListingCheckStores, fetchListingCheckWithStoresInfo, sortListingProductsData } from "../../../api_calls/listingCheck";
import { ArrowDropDown, ArrowDropUp, Download, Store } from "@mui/icons-material";
import { SmallWidthStyledTableCell, StyledTableCell } from "../../../components/commonComponents/TabularLists/styles";
import ListingCheckStoresList from "../ModalContent/ListingCheckStoresList";

const Results = ({ reduxKeyToLoadResults, reduxKeyToCheckSortedProducts, resultsTitle, campaignRecord, usedFor }) => {
    const userStateDetails = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [fieldErrors, setFieldErrors] = React.useState({});
    // show stores list popup
    const [openStoresListPopup, setOpenStoresListPopup] = React.useState(false);
    const [gtinForStoreList, setGtinForStoreList] = React.useState("");
    // sorting measures for result listing
    const [sortingMeasure, setSortingMeasure] = React.useState({
        gtin: "asc",
        product_name: "desc",
        article_description: "desc",
        store_count: "desc",
    });

    const showRequestCancelButton = (showHideFlag) => {
        dispatchAction(updateStateData({
            show_loading_cancel_button: showHideFlag,
        }));
    }

    // listing check response data
    const listingCheckResponseData = typeof userStateDetails[reduxKeyToLoadResults] !== "undefined" ? userStateDetails[reduxKeyToLoadResults] : {};

    // sorted product list from listing check API response
    const sortedProductList = typeof userStateDetails[reduxKeyToCheckSortedProducts] !== "undefined" && userStateDetails[reduxKeyToCheckSortedProducts].length > 0 ? userStateDetails[reduxKeyToCheckSortedProducts] : [];

    const showDownLoadExcelButton = (
        (typeof sortedProductList !== "undefined" && sortedProductList.length > 0)
        ||
        (typeof listingCheckResponseData.anyGtinCount !== "undefined" && listingCheckResponseData.anyGtinCount > 0) ||
        (typeof listingCheckResponseData.allGtinCount !== "undefined" && listingCheckResponseData.allGtinCount > 0)
    );

    const showListingCheckResults = (
        (typeof sortedProductList !== "undefined")
        ||
        typeof listingCheckResponseData.anyGtinCount !== "undefined" ||
        typeof listingCheckResponseData.allGtinCount !== "undefined"
    );

    // component to render each product row
    const ProductRowMarkup = ({ product }) => {
        return (
            <TableRow>
                <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    {product.gtin}
                </StyledTableCell>
                {/* --------- name ---------- */}
                <StyledTableCell component="td" scope="row" className="text-wrapper wrapLargeText" sx={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    {typeof product.description !== "undefined" && product.description !== null && product.description !== "" ? product.description : "-"}
                </StyledTableCell>
                {/* ----- article description (only shown in products popup)----- */}
                {
                    typeof campaignRecord !== "undefined" && campaignRecord !== null && (
                        <StyledTableCell component="td" scope="row" className="text-wrapper wrapLargeText" sx={{ paddingTop: "5px", paddingBottom: "5px" }}>
                            {typeof product.article_description !== "undefined" && product.article_description !== null && product.article_description !== "" ? product.article_description : "-"}
                        </StyledTableCell>
                    )
                }
                {/* ---------- store count --------- */}
                <SmallWidthStyledTableCell component="td" scope="row" sx={{ paddingTop: "5px", paddingBottom: "5px", width: "180px" }}>
                    <StyledStack direction="row" spacing={2}>
                        <Link
                            href="#"
                            underline="none"
                            title={""}
                            sx={{ color: "#AF3241" }}
                            onClick={(e) => {
                                e.preventDefault();
                                const storeIds = product.storeIds === null ? [] : product.storeIds;
                                fetchListingCheckStores(storeIds).then(() => {
                                    setGtinForStoreList(product.gtin);
                                    setOpenStoresListPopup(true);
                                });
                            }}
                        >
                            <IconContainer>
                                <Store sx={{ color: "#AF3241" }} />
                                <IconText variant="body2"> {product.storeCount === null ? 0 : product.storeCount} </IconText>
                            </IconContainer>
                        </Link>
                    </StyledStack>
                </SmallWidthStyledTableCell>
            </TableRow>
        )
    }

    return (
        <>
            {
                typeof userStateDetails[reduxKeyToLoadResults] !== "undefined" &&
                <Box>

                    {
                        usedFor === "savedListingCheck" &&
                        <Typography variant="body2">
                            Use the Listing Check to verify in how many of your stores the respective products are available for sale. The check is based on GTINs across all stores available for this campaign.
                        </Typography>
                    }

                    <Box height={20} />
                    <Typography variant="h6" gutterBottom sx={{ fontSize: "18px" }}>
                        {resultsTitle}
                    </Typography>
                    <Box height={5} />
                    <StyledDarkRedInformationTypography variant="body2">
                        <i>
                            Confidential: The data shown in this dashboard and in related exports is highly sensitive and intended for internal use only. It must not be shared with external partners or third parties without prior permission by Cyreen.
                        </i>
                    </StyledDarkRedInformationTypography>
                    <Box height={10} />
                    <TableContainer component={Paper} sx={{ minWidth: 800 }}>
                        <Table sx={{ minWidth: 800 }} aria-label="customized table">
                            {/* ------ header row ------ */}
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="left" className="text-wrapper">
                                        <Stack direction={"row"} spacing={1}>
                                            <div>GTIN</div>
                                            {sortingMeasure.gtin === "asc" ? (
                                                <ArrowDropDown
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setSortingMeasure((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                gtin: prevState.gtin === "asc" ? "desc" : "asc",
                                                            };
                                                        });
                                                        // sort the listing in redux state
                                                        sortListingProductsData("gtin", sortingMeasure.gtin === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                    }}
                                                />
                                            ) : (
                                                <ArrowDropUp
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setSortingMeasure((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                gtin: prevState.gtin === "asc" ? "desc" : "asc",
                                                            };
                                                        });
                                                        // sort the listing in redux state
                                                        sortListingProductsData("gtin", sortingMeasure.gtin === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                    }}
                                                />
                                            )}
                                        </Stack>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className="text-wrapper" >
                                        <Stack direction={"row"} spacing={1}>
                                            <div>Product Name (from Sales Data)</div>
                                            {sortingMeasure.product_name === "asc" ? (
                                                <ArrowDropDown
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setSortingMeasure((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                product_name: prevState.product_name === "asc" ? "desc" : "asc",
                                                            };
                                                        });
                                                        // sort the listing in redux state
                                                        sortListingProductsData("product_name", sortingMeasure.product_name === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                    }}
                                                />
                                            ) : (
                                                <ArrowDropUp
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setSortingMeasure((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                product_name: prevState.product_name === "asc" ? "desc" : "asc",
                                                            };
                                                        });
                                                        // sort the listing in redux state
                                                        sortListingProductsData("product_name", sortingMeasure.product_name === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                    }}
                                                />
                                            )}
                                        </Stack>
                                    </StyledTableCell>
                                    {/* ----- article description (only shown in products popup)----- */}
                                    {
                                        typeof campaignRecord !== "undefined" && campaignRecord !== null && (
                                            <StyledTableCell align="left" className="text-wrapper" >
                                                <Stack direction={"row"} spacing={1}>
                                                    <div>Article Description</div>
                                                    {sortingMeasure.article_description === "asc" ? (
                                                        <ArrowDropDown
                                                            sx={{ cursor: "pointer" }}
                                                            onClick={(e) => {
                                                                setSortingMeasure((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        article_description: prevState.article_description === "asc" ? "desc" : "asc",
                                                                    };
                                                                });
                                                                // sort the listing in redux state
                                                                sortListingProductsData("article_description", sortingMeasure.article_description === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                            }}
                                                        />
                                                    ) : (
                                                        <ArrowDropUp
                                                            sx={{ cursor: "pointer" }}
                                                            onClick={(e) => {
                                                                setSortingMeasure((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        article_description: prevState.article_description === "asc" ? "desc" : "asc",
                                                                    };
                                                                });
                                                                // sort the listing in redux state
                                                                sortListingProductsData("article_description", sortingMeasure.article_description === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                            }}
                                                        />
                                                    )}
                                                </Stack>
                                            </StyledTableCell>
                                        )
                                    }
                                    <SmallWidthStyledTableCell align="left" sx={{ width: "180px" }}>
                                        <StyledStack direction="row" spacing={2}>
                                            <div>Stores with Sales</div>
                                            {sortingMeasure.store_count === "asc" ? (
                                                <ArrowDropDown
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setSortingMeasure((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                store_count: prevState.store_count === "asc" ? "desc" : "asc",
                                                            };
                                                        });
                                                        // sort the listing in redux state
                                                        sortListingProductsData("store_count", sortingMeasure.store_count === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                    }}
                                                />
                                            ) : (
                                                <ArrowDropUp
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setSortingMeasure((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                store_count: prevState.store_count === "asc" ? "desc" : "asc",
                                                            };
                                                        });
                                                        // sort the listing in redux state
                                                        sortListingProductsData("store_count", sortingMeasure.store_count === "asc" ? "desc" : "asc", reduxKeyToLoadResults, reduxKeyToCheckSortedProducts);
                                                    }}
                                                />
                                            )}
                                        </StyledStack>
                                    </SmallWidthStyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    showListingCheckResults === true ? (
                                        <>
                                            {typeof sortedProductList !== "undefined" && sortedProductList.length > 0 ?
                                                sortedProductList.map((product, index) => {
                                                    return (
                                                        <ProductRowMarkup key={"listing_check_records_" + index} product={product} />
                                                    );
                                                }) : (
                                                    <>
                                                        {
                                                            typeof userStateDetails.checked_gtin_values !== "undefined" && userStateDetails.checked_gtin_values.length > 0 && userStateDetails.checked_gtin_values.map((gtin, index) => {
                                                                return <ProductRowMarkup key={"listing_check_no_result_row_" + index} product={{ gtin: gtin, description: "-", storeCount: 0, storeIds: [] }} />;
                                                            })
                                                        }
                                                    </>
                                                )}
                                            {/* -------- any/all gtin rows ------ */}
                                            {
                                                typeof listingCheckResponseData.anyGtinCount !== "undefined" && (
                                                    <TableRow>
                                                        <StyledTableCell component="td" colSpan={typeof campaignRecord !== "undefined" && campaignRecord !== null ? 3 : 2} scope="row" className="text-wrapper" sx={{ paddingTop: "5px", paddingBottom: "5px", backgroundColor: "#e0e0e3ff", borderBottom: "1px solid #a5a5a8ff" }}>
                                                            <StyledRightAlignedStack direction="row" spacing={1} justifyContent="flex-end">
                                                                <strong>Any GTIN</strong>
                                                            </StyledRightAlignedStack>

                                                        </StyledTableCell>
                                                        {/* ---------- store count --------- */}
                                                        <SmallWidthStyledTableCell component="td" scope="row" sx={{ paddingTop: "5px", paddingBottom: "5px", backgroundColor: "#e0e0e3ff", borderBottom: "1px solid #a5a5a8ff", width: "180px" }} >
                                                            <StyledStack direction="row" spacing={2}>
                                                                <Link
                                                                    href="#"
                                                                    underline="none"
                                                                    title={""}
                                                                    sx={{ color: "#AF3241" }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        fetchListingCheckStores(listingCheckResponseData.anyGtinList).then(() => {
                                                                            setGtinForStoreList("Any GTIN");
                                                                            setOpenStoresListPopup(true);
                                                                        });
                                                                    }}
                                                                >
                                                                    <IconContainer>
                                                                        <Store sx={{ color: "#AF3241" }} />
                                                                        <IconText variant="body2"> {listingCheckResponseData.anyGtinCount} </IconText>
                                                                    </IconContainer>
                                                                </Link>
                                                            </StyledStack>
                                                        </SmallWidthStyledTableCell>
                                                    </TableRow>
                                                )
                                            }
                                            {
                                                typeof listingCheckResponseData.allGtinCount !== "undefined" && (
                                                    <TableRow>
                                                        <StyledTableCell component="td" colSpan={typeof campaignRecord !== "undefined" && campaignRecord !== null ? 3 : 2} scope="row" className="text-wrapper" sx={{ paddingTop: "5px", paddingBottom: "5px", backgroundColor: "#e0e0e3ff", borderBottom: "1px solid #a5a5a8ff" }}>
                                                            <StyledRightAlignedStack direction="row" spacing={1} justifyContent="flex-end">
                                                                <strong>All GTINs</strong>
                                                            </StyledRightAlignedStack>
                                                        </StyledTableCell>
                                                        {/* ---------- store count --------- */}
                                                        <SmallWidthStyledTableCell component="td" scope="row" sx={{ paddingTop: "5px", paddingBottom: "5px", backgroundColor: "#e0e0e3ff", borderBottom: "1px solid #a5a5a8ff", width: "180px" }} >
                                                            <StyledStack direction="row" spacing={2}>
                                                                <Link
                                                                    href="#"
                                                                    underline="none"
                                                                    title={""}
                                                                    sx={{ color: "#AF3241" }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        fetchListingCheckStores(listingCheckResponseData.allGtinList).then(() => {
                                                                            setGtinForStoreList("All GTINs");
                                                                            setOpenStoresListPopup(true);
                                                                        });
                                                                    }}
                                                                >
                                                                    <IconContainer>
                                                                        <Store sx={{ color: "#AF3241" }} />
                                                                        <IconText variant="body2"> {listingCheckResponseData.allGtinCount} </IconText>
                                                                    </IconContainer>
                                                                </Link>
                                                            </StyledStack>
                                                        </SmallWidthStyledTableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </>
                                    ) :
                                        (
                                            <></>
                                        )
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* --------- download excel button -------- */}
                    <SpaceBetweenStack
                        direction="row"
                        spacing={2}
                        width="100%"
                        height={"40px"}
                        justifyContent="space-between"
                        // alignItems="flex-start"     // ⬅️ add this
                        mt={showDownLoadExcelButton === true ? 0 : 3}
                        mb={usedFor === "savedListingCheck" ? 0 : 2}
                    >
                        <StyledDarkRedInformationTypography variant="body2">
                            Checked Stores: {typeof listingCheckResponseData.checkedStoresCount !== "undefined" ? listingCheckResponseData.checkedStoresCount : 0}
                        </StyledDarkRedInformationTypography>
                        {/* --------- download button -------- */}
                        <Box
                            display="flex"
                            alignItems="center"
                            ml={2}
                            height={"40px"}
                            alignSelf="flex-start"  // ⬅️ ensures top alignment
                        >
                            {
                                showDownLoadExcelButton === true && (
                                    <TextButton
                                        onClick={(e) => {
                                            e.preventDefault();
                                            showRequestCancelButton(true);
                                            const campaignName = typeof campaignRecord !== "undefined" && campaignRecord !== null && typeof campaignRecord.campaign_name !== "undefined" ? campaignRecord.campaign_name : "";
                                            fetchListingCheckWithStoresInfo(campaignName, usedFor);
                                        }}
                                        label={"Download Excel"}
                                        sx={{ paddingTop: "0px" }}
                                        icon={<Download />}
                                    />
                                )
                            }

                        </Box>
                    </SpaceBetweenStack>

                    {/* ----- saved on date (if applicable) ------ */}
                    {
                        usedFor === "savedListingCheck" && (
                            <Stack direction={"column"} spacing={1} mb={2}>
                                <StyledDarkRedInformationTypography variant="body2">
                                    Saved On: {typeof userStateDetails.listing_check_saved_on !== "undefined" && userStateDetails.listing_check_saved_on !== null ? userStateDetails.listing_check_saved_on : "-"}
                                </StyledDarkRedInformationTypography>
                                <StyledDarkRedInformationTypography variant="body2">
                                    Saved as: {typeof userStateDetails.listing_check_saved_type !== "undefined" && userStateDetails.listing_check_saved_type !== null ? userStateDetails.listing_check_saved_type : "-"}
                                </StyledDarkRedInformationTypography>
                            </Stack>

                        )
                    }
                </Box>
            }

            {/* ------------ stores popup ---------- */}
            {openStoresListPopup === true && (
                <ListingCheckStoresList
                    open={openStoresListPopup}
                    selectedGtin={gtinForStoreList}
                    closeModal={() => {
                        setOpenStoresListPopup(false);
                        setGtinForStoreList("");
                    }}
                />
            )}
        </>
    );
};

export default Results;
